const sanitizeHtml = require('sanitize-html');
const { query, sitemapNames } = require('./Constants');

const resolvePageUri = ({slug, uri, isPostsPage}) =>
{
    if ( !isPostsPage ) return uri || '';
    return `/${slug}/`;
}

const resolvePostDate = ({dateGmt, cdmfields}) =>
{
    const { post_updated_date:updatedDate } = cdmfields.eat;
    if (!updatedDate) return dateGmt;
    return `${updatedDate}T${dateGmt.split('T').pop()}`;
}
const resolveFeaturedImage = ({featuredImage, cdmfields}, GATSBY_SITE_URL) =>
{
    const imageUrl = featuredImage?.node?.localFile?.childImageSharp?.fluid?.srcWebp || 
        featuredImage?.node?.localFile?.childImageSharp?.fluid?.src;
    const legacyImageUrl = cdmfields?.legacymeta?.qlmigArticleImage;
    if ( legacyImageUrl ) return sanitizeHtml(legacyImageUrl);
    return imageUrl ? sanitizeHtml(`${GATSBY_SITE_URL}${imageUrl}`) : null;
}

module.exports = {
    config: (GATSBY_SITE_URL) => ({
        query,
        exclude: [
            '/404'
        ],
        output: sitemapNames.index,
        mapping: {
            allWpPage: {
                sitemap: sitemapNames.page,
                serializer: (edges) =>
                    edges.map( (edge) =>
                        ({
                            ...edge,
                            node: {
                                ...edge.node,
                                slug: sanitizeHtml(resolvePageUri( edge.node ))
                            }
                        })
                    )
            },
            allWpPost: {
                sitemap: sitemapNames.post,
                serializer: (edges) =>
                    edges.map( (edge) =>
                        ({
                            ...edge,
                            node: {
                                ...edge.node,
                                slug: sanitizeHtml(edge.node.uri || ''),
                                updated_at: sanitizeHtml(resolvePostDate( edge.node )),
                                feature_image: resolveFeaturedImage( edge.node, GATSBY_SITE_URL),
                            }
                        })
                    )
            },
            allWpUser: {
                sitemap: sitemapNames.user,
                serializer: (edges) =>
                    edges.map( (edge) =>
                        ({
                            ...edge,
                            node: {
                                ...edge.node,
                                slug: sanitizeHtml(edge.node.uri || '')
                            }
                        })
                    )
            },
            allWpCategory: {
                sitemap: sitemapNames.category,
                serializer: (edges) =>
                    edges.map( (edge) =>
                        ({
                            ...edge,
                            node: {
                                ...edge.node,
                                slug: sanitizeHtml(edge.node.uri || '')
                            }
                        })
                    )
            },
        }
    })
}
